const newsletter = `
# eBL Newsletter 20

## 10 September 2025

### Library

- The translation is now displayed in parallel columns: see e.g.
  [IM.67692](https://www.ebl.lmu.de/library/IM.67692)
- A simplified view of editions has been implemented, under URL + \`/html\`,
  e.g. [https://www.ebl.lmu.de/library/K.3/html](https://www.ebl.lmu.de/library/K.3/html)
  - Its purpose is to enable other projects to embed fragments from eBL in
    external sites.
  - In the simplified view, [all languages](https://ebl.badw.de/library/U.4268/html)
    are shown by default, which can be limited to a single language with a URL
    parameter \`?lang=\` followed by a 2-character language code, e.g., \`en\`
    for [English](https://ebl.badw.de/library/U.4268/html?lang=en) and \`ar\`
    for [Arabic](https://ebl.badw.de/library/U.4268/html?lang=ar).
- A new interface for lemmatising, based on best practices in Computer
  Linguistics, has been implemented. The new interface should speed up the
  process of lemmatising considerably. See the small introduction
  [here](https://syncandshare.lrz.de/getlink/fiXLc2zR58m7STmn9cYTps/How%20to_%20Annotate%20Lemmas.pdf).
- A new interface for annotating entity types has been implemented.
- New photos:
  - Some 120 photos of Nippur (IM.58477–61464) and Ur (IM.136452–136942)
    tablets in the Iraq Museum have been imported.
  - Some 1000 photos from the British Museum’s Babylonian (BM.13433–14302) and
    Sippar Collections (BM.49480–50937) have been uploaded.
  - The import of 5600 newly registered British Museum fragments has been
    finished (these are now labelled as “Newly Registered Fragments Collection”): 
    - 1876,1117.2628–2811
    - 1880,0617.1959–3001
    - 1880,1112.2174–2638
    - 1881,0324.369–442
    - 1881,0728.261–387
    - 1881,083.932–1031
    - 1881,1103.1967–2116.bis
    - 1884,0211.599–946
    - 1959,0414.93–125
    - 2023,6003.2–815
    - 2024,6004.1–401
    - F.1–235.A
    - K.22304–23196
    - Rm.1117–1341
    - Rm-IV.542–824
    - Sp.660–825
    - Sp-II.1087–1172
    - Sp-III.836–938 
- New folios:
  -	The Folios Aaboe and Britton, kindly made available by John Steele, have
    been added to the Library.
  - The Library now shows links to the About page on the Folio tabs.
- Collections:
  - The Ashmolean Museum’s cuneiform collection has been imported.


### Corpus
- A Latin translation of the *Dialogue of Pessimism* (Sarabia 2024) has been
  added.`

export default newsletter
